import React from 'react';
import Button from 'plaid-threads/Button';

import { Banner, AddUserForm } from '.';

import { useBoolean } from '../hooks';

const Landing: React.FC = () => {
  // const { userState, setCurrentUser } = useCurrentUser();

  const [isAdding, hideForm, toggleForm] = useBoolean(false);

  return (
    <div>
      <Banner initialSubheading />

      <Button className="btnWithMargin" onClick={toggleForm} centered inline>
        Create Account
      </Button>

      {isAdding && <AddUserForm hideForm={hideForm} />}
    </div>
  );
};

Landing.displayName = 'Landing';

export default Landing;
